module.exports = __webpack_public_path__ + "static/media/empty-groups.07073805.png";